module.exports = __webpack_public_path__ + "img/TV_Adverts_1_Background.24f09649.jpg";